import { Layout } from './Layout';
import { StyledHeader as H2 } from './GeneralText';
import { CardText } from './CardText';
import styled from 'styled-components';
import { AnchorHTMLAttributes, ReactElement } from 'react';

type FullBleedProps = {
  header: string;
  id: string;
  text?: string;
  title?: string;
  icon?: ReactElement;
  children?: React.ReactNode;
  [rest: string]: any;
};

export function FullBleedCard({header, title, text, id, icon, children}: FullBleedProps) {
  return (
    <Wrapper>
      <Layout>
        <H2Container id={id} icon={icon}>
          <H2>{header}</H2>
          {icon && <IconWrapper>
            <IconContainer>
              {icon}
            </IconContainer>
          </IconWrapper>}
        </H2Container>
        <Content>
          {title && <Title>{title}</Title>}
          {text && <CardText>{text}</CardText>}
          {children}
        </Content>
      </Layout>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: var(--color-gray-light);
  padding-block: 2rem;
`;
interface H2ContainerProps {
  icon?: ReactElement;
}
const H2Container = styled.div<H2ContainerProps>`
  grid-column: 1/-1;
  display: flex;
  margin: auto;
  transform: ${({ icon }) => icon !== undefined ? "translateX(-20px)" : "none"};
  
  @media (max-width: 820px) {
      max-width: calc(100% - 90px);
  }
`;
const IconWrapper = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  width: 60px;
  height: 100%;
  text-align: center;
  background: none;
  text-decoration: none;
  color: black;
  margin-right: -60px
`;
const IconContainer = styled.div`
  max-width: 90px;
  margin: auto;
`;
const Content = styled.div`
  grid-column: 2 / -2;
  display: flex;
  flex-direction: column;
  padding: 1em 0;
  gap: var(--gap);
  font-family: var(--heading-font), sans-serif;
  color: var(--color-blue);
`;
const Title = styled.h2`
  font-size: clamp(1.3rem, -3rem + 9vw, 1rem);
  width: max-content;
  margin: auto;
  word-break: break-word;
  max-width: 100%;
`;